import { Button } from "@/components/ui/button";
import { ShieldCheck, Award, BadgePercent } from "lucide-react";

export default function HeroSection({ onCTAClick }) {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-gradient-to-br from-white via-slate-50 to-white pt-24">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%230f172a' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="container mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Content */}
          <div className="space-y-8 animate-fade-in-up">
            {/* Trust Badge */}
            <div className="inline-flex items-center gap-2 bg-slate-100 px-4 py-2 rounded-full">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
              <span className="text-sm font-medium text-slate-700">
                Över 500 nöjda kunder sedan 2010
              </span>
            </div>

            {/* H1 - Primary SEO Keyword */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-[1.1] tracking-tight">
              Professionell fasadmålning – hållbart, snyggt och tryggt
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-slate-600 leading-relaxed max-w-xl">
              Vi hjälper villaägare och fastighetsägare med utvändig målning av högsta kvalitet. 
              Fast pris, garanti och ROT-avdrag ingår.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                data-testid="hero-cta-button"
                onClick={onCTAClick}
                className="bg-[#b91c1c] hover:bg-[#991b1b] text-white h-14 px-8 rounded-full text-lg font-semibold shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
              >
                Få kostnadsfri offert
              </Button>
              <Button 
                data-testid="hero-secondary-button"
                variant="outline"
                onClick={onCTAClick}
                className="border-2 border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white h-14 px-8 rounded-full text-lg font-medium transition-all"
              >
                Ring oss direkt
              </Button>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-6 pt-4">
              <div className="flex items-center gap-2 text-slate-700">
                <ShieldCheck className="w-5 h-5 text-[#b91c1c]" />
                <span className="text-sm font-medium">Specialister på trähus</span>
              </div>
              <div className="flex items-center gap-2 text-slate-700">
                <BadgePercent className="w-5 h-5 text-[#b91c1c]" />
                <span className="text-sm font-medium">ROT-avdrag</span>
              </div>
              <div className="flex items-center gap-2 text-slate-700">
                <Award className="w-5 h-5 text-[#b91c1c]" />
                <span className="text-sm font-medium">Nöjd-kund-garanti</span>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative hidden lg:block animate-fade-in animation-delay-200">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_9628547f-dbd1-447b-abd5-f19c4c5b0b86/artifacts/htw1i97k_Fasadmalning%205.jpg"
                alt="Vi Målar Sverige AB fasadmålning av gult trähus med ställning"
                className="w-full h-[500px] object-cover"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent" />
            </div>
            
            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 shadow-xl border border-slate-100">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#b91c1c]/10 rounded-full flex items-center justify-center">
                  <Award className="w-6 h-6 text-[#b91c1c]" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">15+</p>
                  <p className="text-sm text-slate-600">År i branschen</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
